export enum ProductLocationsColumns {
  ProductName = 'product_name',
  ProductExternalId = 'product_external_id',
  LocationName = 'location_name',
  LocationExternalId = 'location_external_id',
  StoreTransferEnabled = 'is_store_transfer_enabled',
  Price = 'product_price',
  SaleRate = 'sale_rate',
  ProductGlobalSaleRate = 'product_global_sale_rate',
  Brands = 'product_brand_names',
  Seasons = 'product_season_names',
  Categories = 'product_category_names',
  DepartmentName = 'product_department_names',
  AG = 'product_assortment_group_name',
}
